const ContractActionTypes = {
  SET_CONTRACTS: "contract/SET_CONTRACTS",
  SET_CONTRACT: "contract/SET_CONTRACT",
  SWITCH_CONTRACT: "contract/SWITCH_CONTRACT",
};

export default ContractActionTypes;
